// Checklist: tipos e nomes compartilhados (biblioteca, ajustes por cliente, ficha da OS).

export const NOME_TIPO_RESPOSTA: Record<string, string> = {
  ok_nok: 'OK / NOK', sim_nao: 'Sim / Não', numero: 'Número (medição)', texto: 'Texto', opcao: 'Escolha entre opções', foto: 'Foto',
};
export const NOME_EXIGE_FOTO: Record<string, string> = { nunca: 'Não pede foto', sempre: 'Sempre pede foto', se_nok: 'Foto se der problema' };
export const NOME_PENDENCIA: Record<string, string> = { orcamento: 'Orçamento', retorno: 'Retorno', peca: 'Peça', cliente: 'Ação do cliente' };
export const NOME_ACAO_AJUSTE: Record<string, string> = {
  esconder: 'Esconder item', obrigar: 'Tornar obrigatório', dispensar: 'Tornar opcional', acrescentar: 'Acrescentar item',
};
export const NOME_NATUREZA: Record<string, string> = {
  corretiva: 'Corretiva', preventiva: 'Preventiva', instalacao: 'Instalação', remota: 'Remota', vistoria: 'Vistoria', entrega: 'Entrega', retorno: 'Retorno',
};
export const NOME_SITUACAO: Record<string, string> = { ok: 'OK', nok: 'NOK', na: 'Não se aplica' };

export interface ItemBiblioteca {
  id: string; bloco_id: string; codigo: string; ordem: number; texto: string; ajuda: string | null; tipo_resposta: string;
  opcoes: string[] | null; nok_valores: string[] | null; unidade: string | null; minimo: string | null; maximo: string | null;
  obrigatorio: boolean; exige_foto: string; pendencia_tipo: string | null; bloqueante: boolean; ativo: boolean; versao: number;
}
export interface Bloco {
  id: string; nome: string; descricao: string | null; natureza: string | null; tipo_os_id: string | null; tipo_os: string | null;
  natureza_efetiva: string; categoria_id: string | null; categoria: string | null; escopo_ativo: 'todos_do_local' | 'escolhidos';
  ordem: number; ativo: boolean; versao: number; ajustes: number; usado_em_os: number; itens: ItemBiblioteca[];
}
export interface Ajuste {
  id: string; cliente_id: string | null; local_id: string | null; local: string | null; bloco_id: string; bloco: string;
  acao: string; item_codigo: string; item_texto: string | null; motivo: string; criado_em: string; criado_por: string | null;
}
export interface Regra { opcoes?: string[] | null; nok_valores?: string[] | null; unidade?: string | null; minimo?: number | null; maximo?: number | null; exige_foto?: string; pendencia_tipo?: string | null; bloqueante?: boolean }
export interface ItemOs {
  id: string; ativo_id: string | null; ativo: string | null; bloco_id: string; bloco: string; codigo: string; ordem: number; texto: string; ajuda: string | null;
  tipo_resposta: string; regra: Regra; obrigatorio: boolean; resposta: string | null; valor_numero: string | null; observacao: string | null;
  situacao: 'ok' | 'nok' | 'na' | null; foto_ids: string[]; respondido_em: string | null; respondido_por: string | null; ajustado: boolean;
}
export interface ChecklistOs {
  itens: ItemOs[]; obrigatorios_pendentes: number;
  sob_demanda: { bloco_id: string; nome: string; ativos_elegiveis: { id: string; apelido: string }[] }[];
}

/** Agrupa os itens da OS por bloco e por equipamento, na ordem em que chegam da API. */
export function agrupar(itens: ItemOs[]) {
  const grupos: { chave: string; bloco: string; ativo: string | null; itens: ItemOs[] }[] = [];
  for (const i of itens) {
    const chave = `${i.bloco_id}|${i.ativo_id ?? ''}`;
    let g = grupos.find((x) => x.chave === chave);
    if (!g) { g = { chave, bloco: i.bloco, ativo: i.ativo, itens: [] }; grupos.push(g); }
    g.itens.push(i);
  }
  return grupos;
}

/** Texto curto da regra do item (faixa, foto, pendência) para quem configura e para quem confere. */
export function resumoRegra(i: { tipo_resposta: string; unidade?: string | null; minimo?: string | number | null; maximo?: string | number | null; opcoes?: string[] | null; nok_valores?: string[] | null; exige_foto?: string; pendencia_tipo?: string | null }) {
  const p: string[] = [NOME_TIPO_RESPOSTA[i.tipo_resposta] ?? i.tipo_resposta];
  if (i.tipo_resposta === 'numero' && (i.minimo != null || i.maximo != null)) p.push(`aceita ${i.minimo ?? '…'} a ${i.maximo ?? '…'}${i.unidade ? ` ${i.unidade}` : ''}`);
  else if (i.unidade) p.push(i.unidade);
  if (i.opcoes?.length) p.push(i.opcoes.join(' · '));
  if (i.nok_valores?.length) p.push(`problema se: ${i.nok_valores.map((v) => (v === 'nao' ? 'não' : v)).join(', ')}`);
  if (i.exige_foto && i.exige_foto !== 'nunca') p.push(NOME_EXIGE_FOTO[i.exige_foto]!.toLowerCase());
  if (i.pendencia_tipo) p.push(`NOK gera pendência de ${NOME_PENDENCIA[i.pendencia_tipo]!.toLowerCase()}`);
  return p.join(' · ');
}
